import React from "react";
import { useEffect, useState, useContext, useRef } from "react";
import { AccountContext } from "../contexts/AccountContext";
import buildLink, { path } from "../urls";
import _axios from "../axios";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { GrSecure } from "react-icons/gr";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import NewLoader from "../components/NewLoader";
import { IoWarning } from "react-icons/io5";

function SignUp() {
  const [state, dispatch] = useContext(AccountContext);
  const [disable,setDisable]=useState(true);
  const [signupError, setSignupError] = useState("");
  const [showSignupError, setShowSignupError] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [openEyesPassword, setOpenEyesPassword] = useState(false);
  const [type, setType] = useState("phoneSignupCheck");
  const identifierRef = useRef(null);
  const signupEmail = useRef("");
  const signupPassword = useRef("");
  const signupFirst = useRef("");
  const signupLast = useRef("");
  const signuptelehone = useRef("");
  const authRef = useRef("");
  const intervalRefSms = useRef(null);
  const [phoneVerified, setphoneVerified] = useState("");
  const [LoadingSendCode, setLoadingSendCode] = useState(false);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const navigate = useNavigate();
  const width = window.innerWidth;
  const [showPassword, setShowPassword] = useState(false);
  const [counterOtp, setCounterOtp] = useState(0);
  const [error, setError] = useState(null);
  const [phoneNotExist, setPhoneNotExist] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleStartCountOtp = () => {
    intervalRefSms.current = 30;

    intervalRefSms.current = setInterval(() => {
      setCounterOtp((prevCounter) => {
        if (prevCounter === 1) {
          clearInterval(intervalRefSms.current);

          intervalRefSms.current = null;
          return 0;
        } else {
          return prevCounter - 1;
        }
      });
    }, 1000);
  };

  const handleSetError = (error) => {
    setError(error);
    setTimeout(() => {
      setError(null);
    }, 10000);
  };

  const sendOtpForSignUpTelephon = async () => {

    try {
      const rawNumber = identifierRef?.current?.value?.trim();

      if (!isValidLebaneseNumber(rawNumber)) {
        handleSetError("Please Enter a valid number");
        return;
      }


      if (identifierRef?.current?.value === "") {
        handleSetError("Enter Your Number");
        return null;
      }
      setLoadingSendCode(true);
      let formData = {
        local: true,
        type: "register",
        authenticated_telephone_otp: 1,
        identifier: identifierRef.current.value,
        redirect: false,
      };
 
      const source = axios.CancelToken.source();
      const response = await _axios.post(
        buildLink("send_OTP", undefined, window.innerWidth),
        formData,
        {
          cancelToken: source.token,
        }
      );
      
      if (response.data.success) {
        setCounterOtp(30);
        handleStartCountOtp();
        setDisable(false);
      } else if (!response.data.success && response.data.redirect === "login") {
        handleSetError("This Number Already Exists. Enter Password To Login");
        setTimeout(() => {
          navigate('/login', {
            state: {
              phonetype: "phoneLogin",
              phone: identifierRef?.current?.value
            }
          });
        }, 1000);
        
      }
       else if (!response.data.success && response.data.errors) {
        handleSetError(response.errors[0].errorMsg);
        setPhoneNotExist(identifierRef.current.value);
      }
      setLoadingSendCode(false);
    } catch (err) {
      handleSetError(err.message);
      setLoadingSendCode(false);
    }
  };

  useEffect(() => {
    if (state.loged) {
      navigate("/");
    }
  }, [state.loged]);

  //sign up
  function signup(e) {
    e.preventDefault();
    setSignupLoading(true);
    const email = signupEmail.current.value;
    const password = signupPassword.current.value;
    const confirm = signupPassword.current.value;
    const firstname = signupFirst.current.value;
    const lastname = signupLast.current.value;
    const telephone = signuptelehone.current.value;
    const verified = 1;
    const obj = JSON.stringify({
      email,
      password,
      firstname,
      lastname,
      confirm,
      telephone,
      verified,
    });
    _axios.post(buildLink("register"), obj).then((response) => {
      const data = response.data;
      if (!data.success) {
        setShowSignupError(true);
        setSignupError(data?.errors[0]?.errorMsg);
        console.log(data?.errors[0]?.errorMsg);
      } else {
        //console.log(data);

        checkLogin();
        navigate("/");
      }
      setSignupLoading(false);
    });
  }

  async function validatePhoneNumberSignUp() {
    try {
      setLoadingRegister(true);
      const res = await _axios.post(buildLink("verifyTelephoneCode"), {
        otpNumber: authRef.current.value,
        redirect: false,
      });
      if(identifierRef?.current?.value === "" || authRef?.current?.value === ""){
        handleSetError("Phone Number & Code are required !");
        return;
      }
      if (res.data.success) {
        setLoadingRegister(false);
        setphoneVerified(identifierRef.current.value);
        setType("phoneSignup");
      } else {
        handleSetError(res.error);
        setLoadingRegister(false);
      }
    } catch (err) {
      console.log(err);
      
      handleSetError("something went wrong !");
    }
  }


  const handleClickEyeButton = () => {
    setOpenEyesPassword((prevState) => !prevState);
  };

  function checkLogin() {
    dispatch({ type: "setLoading", payload: true });
    _axios
      .get(buildLink("login", undefined, window.innerWidth))
      .then((response) => {
        const data = response.data;

        dispatch({ type: "setShowOver", payload: false });
        if (data.customer_id > 0) {
          dispatch({ type: "setLoged", payload: true });
          dispatch({ type: "setUsername", payload: data.username });
          dispatch({ type: "setEarnedPoints", payload: data?.points });
          navigate("/");
          window.location.reload();
        } else {
          dispatch({ type: "setLoged", payload: false });
        }
        dispatch({ type: "setLoading", payload: false });
      });
  }

  const isValidLebaneseNumber = (number) => {
    const regex = /^(3|70|71|76|78|79|81|82|83|84|85|86|87|88|89)\d{6}$/;
    return regex.test(number);
  };

  return (
    <div className="checkout-viewport bg-dgrey10">
      <div className="auth-register-mobile md:hidden flex justify-around text-center mt-1.5 items-center text-d24 font-semibold">
        <div
          className={`w-1/2  text-dbasenavy bg-grey-gradient ${"font-normal border-b-2 border-dgrey3"}   text-d20 py-5 flex justify-center relative text-center h-16`}
          onClick={() => navigate("/login")}
        >
          Login
        </div>
        <div
          className={`w-1/2 ${"font-semibold bg-dwhite1 bg-none border-b-8 border-dblue3"} text-dbasenavy bg-grey-gradient  text-d20 py-5 flex justify-center relative text-center h-16`}
        >
          Sign up
        </div>
      </div>
      <div className="md:container">
        <div className="auth-register flex flex-col md:flex-row justify-center -mt-4 md:mt-0 mb-5 pt-5">
          <div
            className={`w-full md:w-1/2 relative px-5 md:block `}
            data-id="register"
          >
            <div className="auth-register__wrapper py-2.5 px-5 md:py-7 md:px-12 md:bg-dwhite1 min-h-full mb-3">
              <div className="authentication-register">
                <div className="auth-box ">
                  <div className="hidden md:block auth__form--title text-d27 text-center text-dborderblack2 m-2.5">
                    Sign up
                  </div>
                  <div>
                    {type === "phoneSignupCheck" ? (
                      <div
                      >
                        <input type="hidden" name="" />
                        {error && (
                          <h2
                            className={`py-2 text-dred4 bg-red-200 flex text-center  overflow-hidden transition-all w-full gap-3 bg-opacity-20 `}
                          >
                            <div className="flex items-start justify-start">
                              <span className="flex items-center gap-2 text-red-600 text-sm">
                                {" "}
                                <IoWarning
                                  style={{ width: "20px", height: "20px" }}
                                  className=" my-auto"
                                />
                                {error}
                              </span>
                            </div>
                          </h2>
                        )}
                        <div className="mt-2 relative">
                          <div className="flex justify-between items-center mb-1">
                            <label>Phone Number</label>
                          </div>
                          <div className="border flex items-center gap-3 border-dgrey3 font-d16 text-dborderblack2 h-14 mb-2.5  w-full outline-none focus:border focus:border-dblack2">
                            <div className="px-3 border-r whitespace-nowrap xl:w-[20%] border-dlabelColor">
                              LBP +961{" "}
                            </div>
                            <input
                              type="number"
                              name="email"
                              ref={identifierRef}
                              required
                              placeholder="Enter Your Phone number"
                              className="  font-d16   w-[60%] outline-none  "
                            />
                          </div>
                        </div>
                        <div className={`error-email text-dred4 hidden`}></div>
                        <div className="  border-opacity-40 border border-[#d5d5d5]  flex flex-row w-full bg-[#d5d5d5] bg-opacity-25   rounded-md ">
                          <input
                            ref={authRef}
                            placeholder="Enter 6-digit Code"
                            className="py-3 custom-cursor-color w-full h-full  px-4  bg-transparent outline-none border-none"
                          ></input>
                          <button
                            disabled={counterOtp > 0 || LoadingSendCode}
                            onClick={() => sendOtpForSignUpTelephon()}
                            type="button"
                            className={` hover:bg-borderbottom px-3 py-2   border border-[#d5d5d5] shadow-dgrey1 w-[70%]  ${
                              counterOtp > 0 && "cursor-not-allowed"
                            }  rounded-e-md`}
                          >
                            {" "}
                            {LoadingSendCode ? (
                              <div className="w-6 flex mx-auto justify-center relative">
                                <NewLoader />
                              </div>
                            ) : counterOtp > 0 ? (
                              <span className="text-sm">
                                Wait{" "}
                                <span className="text-dblue font-bold">
                                  {counterOtp}
                                </span>
                                s
                              </span>
                            ) : (
                              <span>Send Code</span>
                            )}
                          </button>
                        </div>
                        <div
                          className={`error-password text-dred4 hidden`}
                        ></div>
                        <input type="hidden" name="" />
                        <div className="clear hidden overflow-hidden "></div>
                        <label
                          htmlFor=""
                          className="flex text-justify text-d12 my-4 items-center"
                        >
                          <input
                            type="checkbox"
                            name="remember-me"
                            className="h-4 w-4 border-2 border-dbordergrey rounded-sm relative mr-2.5"
                          />
                          <p className="text-sm">Remember me</p>
                        </label>
                      
                        <div className="mt-3.5 relative">
                        <button
                        onClick={() => {
                          validatePhoneNumberSignUp();
                        }}
                        className={`text-d16 h-14 block text-center leading-3 w-full bg-clip-padding text-dwhite1 uppercase z-10 
                          ${disable ? 'bg-gray-400 cursor-not-allowed' : 'bg-dborderblack2'}`}
                        disabled={disable}
                      >
                        Check
                      </button>

                        </div>
                        <div className="w-full border-dplaceHolder mt-5">
                          <Link to="/login"></Link>
                          <h2 className=" text-dlabelColor text-lg">
                            Already have an account ?{" "}
                            <button
                              onClick={() => navigate("/login")}
                              className="font-bold text-dborderblack2 "
                            >
                              Log in
                            </button>
                          </h2>
                        </div>

                      </div>
                    ) : type === "phoneSignup" ? (
                      <form
                        onSubmit={(e) => {
                            signup(e, "phoneSignup");
                        }}
                      >
                        <div className="mt-3.5 relative flex items-center justify-between">
                          <div className="w-488">
                            <input
                              type="text"
                              name=""
                              required
                              ref={signupFirst}
                              className="border w-full border-dgrey3 text-d16 text-dborderblack2 h-14 mb-2.5 px-5 outline-none focus:border focus:border-dblack2"
                              placeholder="First name"
                            />
                            <div
                              className={`error-name text-dred4 hidden`}
                            ></div>
                          </div>
                          <div className="w-488">
                            <input
                              type="text"
                              name=""
                              required
                              ref={signupLast}
                              className="border w-full  border-dgrey3 text-d16 text-dborderblack2 h-14 mb-2.5 px-5 outline-none focus:border focus:border-dblack2"
                              placeholder="Last name"
                            />
                            <div
                              className={`error-name text-dred4 hidden`}
                            ></div>
                          </div>
                        </div>
                        <div className="mt-1 relative w-full">
                          <input
                            type="email"
                            name=""
                            required
                            ref={signupEmail}
                            className="border border-dgrey3 text-d16 w-full text-dborderblack2 h-14 mb-2.5 px-5 outline-none focus:border focus:border-dblack2"
                            placeholder="E-mail address"
                          />
                          <div
                            className={`error-email text-dred4 hidden`}
                          ></div>
                        </div>
                        <div className="mt-1 relative">
                          <input
                            defaultValue={type === "phoneSignup" && phoneVerified}
                            ref={signuptelehone}
                            type="text"
                            name=""
                            className="border border-dgrey3 text-d16 w-full text-dborderblack2 h-14 mb-2.5 px-5 outline-none focus:border focus:border-dblack2"
                            placeholder="Phone number"
                          />
                          <div
                            className={`error-phone text-dred4 hidden`}
                          ></div>
                        </div>
                        <div className="mt-1 mb-1 relative">
                          <button
                            onClick={handleClickEyeButton}
                            type="button"
                            className="absolute right-3 mt-5"
                          >
                            {openEyesPassword ? <FaEye /> : <FaEyeSlash />}
                          </button>

                          <input
                            type={openEyesPassword ? "text" : "password"} 
                            name="password"
                            minLength={6}
                            required
                            ref={signupPassword}
                            className="border border-dgrey3 text-d16 w-full text-dborderblack2 h-14 mb-2.5 px-5 outline-none focus:border focus:border-dblack2"
                            placeholder="Password"
                          />
                        </div>
                        <div className="consent-agreement -mb-1">
                          <div
                            className="flex items-center text-d12 text-justify mb-2.5"
                            style={{ color: "#626262" }}
                          >
                            <input
                              type="checkbox"
                              name="email_allowed"
                              className="h-6 w-8  border-2 border-dbordergrey rounded-sm relative mr-2.5"
                            />
                            <input
                              type="checkbox"
                              name="sms_allowed"
                              className="h-6 w-8  border-2 border-dbordergrey rounded-sm relative mr-2.5 hidden"
                            />
                            <div className="">
                              <p>
                                I would like to receive SMS and electronic
                                messages within the scope of the{" "}
                                <span className="underline">
                                  Illumination Text
                                </span>{" "}
                                to be informed about the campaigns
                              </p>
                            </div>
                          </div>
                          <div
                            className="flex items-center text-d12 text-justify mb-2.5"
                            style={{ color: "#626262" }}
                          >
                            <input
                              required
                              type="checkbox"
                              name="confirm"
                              id="confirmCheckbox"
                              className="h-6 w-8  border-2 border-dbordergrey rounded-sm relative mr-2.5 "
                            />
                            <div className="">
                              <p>
                                I have read and understood the{" "}
                                <span className="underline">
                                  Illumination Text.
                                </span>{" "}
                                I accept the{" "}
                                <span className="underline">
                                  Membership Agreement
                                </span>{" "}
                                within the scope of the Clarification Text.
                              </p>
                            </div>
                          </div>
                          <div
                            className="flex items-center text-d12 text-justify mb-2.5"
                            style={{ color: "#626262" }}
                          >
                            <input
                              type="checkbox"
                              name="tom_pay_allowed"
                              className="h-6 w-8  border-2 border-dbordergrey rounded-sm relative mr-2.5 "
                            />
                            <div className="mb-1">
                              <p>
                                I consent to the sending of electronic
                                commercial messages by TOM Pay within the scope
                                of the{" "}
                                <span className="underline">
                                  Clarification Text.
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="sign-up  mt-3.5 relative">
                          <button
                            type="submit"
                            className="text-d16 bg-dborderblack2 h-14 block text-center 
                                        leading-3 w-full bg-clip-padding text-dwhite1 uppercase "
                          >
                            {" "}
                            {signupLoading ? (
                              <span>LOADING</span>
                            ) : (
                              <span>SIGN UP</span>
                            )}
                          </button>
                          {signupError && (
                            <div
                              className={`error-password text-dred4 mt-2 text-sm`}
                            >
                              {signupError}
                            </div>
                          )}
                        </div>
                        <div className="border-t w-full border-dplaceHolder py-6">
                          <Link to="/login"></Link>
                          <h2 className=" text-dlabelColor text-lg">
                            Already have an account ?{" "}
                            <button
                              onClick={() => navigate("/login")}
                              className="font-bold text-dborderblack2 "
                            >
                              Log in
                            </button>
                          </h2>
                        </div>
                      </form>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="login-register-secure-shopping flex justify-center items-center bg-dgrey10">
          <div className="flex items-center">
            {/* <img
            src="https://akn-eh.b-cdn.net/static_omnishop/eh590/assets/img/insurance.png"
            alt=""
            className="mb-8"
          /> */}
            <GrSecure className="mb-8" />
            <div className="text-d18 text-dborderblack2 ml-2.5 font-semibold mb-8">
              Secure shopping
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
